
import { map, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentUserStateService } from '../../Core/Users/services/current-user-state.service';

@Injectable()
export class LandingPageGuard implements CanActivate {

    constructor(
        private currentUserState: CurrentUserStateService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserState.getState().pipe(
            // Waits til info is fetched from backend
            filter(x => x !== null),
            map(() => {
                return true;
            })
        );
    }

}
